import styled from '~/styles';

export default styled.div`
  flex-grow: 1;
`;
